<template>
  <div class="identity ba-flex md:ba-items-center ba-pt-16 md:ba-pt-32">
    <div
      class="container ba-flex ba-justify-center ba-flex-wrap ba-py-10 ba-content-center md:ba-content-start"
    >
      <vis-login-header />
      <main
        class="identity__wrap ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-content-start"
      >
        <div
          class="md:ba-relative md:ba-z-50 md:ba-flex md:ba-w-full md:ba-h-full md:ba-overflow-y-auto ba-py-16"
        >
          <figure v-if="false" class="ba-hidden md:ba-flex ba-mb-12">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 203 178"
              width="203"
              height="178"
              fill="#1B1D26"
              class="ba-w-48 ba-mx-auto"
            >
              <path
                d="M113.789 134.868h17.167l49.014-91.995h-17.167l-49.014 91.995z"
              />
              <path
                d="M40.103 0C17.988 0 0 19.217 0 42.85v92.3C0 158.783 17.988 178 40.103 178h68.057l7.81-14.73H40.103c-14.001 0-25.399-12.615-25.399-28.12v-92.3c0-15.505 11.398-28.12 25.399-28.12l121.059-.4L168.76 0H40.103zm145.543 0l-7.693 14.377 17.402-.047L203 0h-17.354z"
              />
              <path
                d="M84.286 114.43L46.13 42.873H28.87l49.037 91.995h12.524l49.085-91.995h-17.027L84.286 114.43z"
              />
            </svg>
          </figure>
          <img
            v-if="false"
            src="/img/rhombus.svg"
            class="ba-hidden lg:ba-block ba-absolute ba-bottom-1/5 ba-right-10 xl:ba--right-1/12"
          />
          <img
            v-if="false"
            src="/img/stairs.svg"
            class="ba-hidden lg:ba-block ba-absolute ba-bottom-1/5 ba--left-1/6"
          />
          <slot />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import VisLoginHeader from "./vis-login-header";

export default {
  name: "vis-login-layout",
  components: {
    VisLoginHeader
  }
};
</script>
